import React from "react";
import c from "./AccommodationPackageMobile.module.scss";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getHotelSelector } from "../../../../../../../../store/hotel/hotel-selector";
import dayjs from "dayjs";
import { RoomItemPriceType } from "../../../../../../../../types/rooms";
import { getDifferenceInNights } from "../../../../../../../../helpers/date";
import RoomPriceMealIcon from "../../../../../../../../components/ui/icons/hotels/rooms/RoomPriceMealIcon";
import AppButton from "../../../../../../../../components/ui/components/Buttons/AppButton/AppButton";


interface IProps {
  children?: React.ReactNode;
  price: RoomItemPriceType;
  accommodationPacket: {
    arrivalDate: string
    departureDate: string
  }
}


const AccommodationPackageMobile: React.FC<IProps> = ({ price, accommodationPacket }) => {
  const [t] = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const {alias} = useSelector(getHotelSelector).data;
  const {
    arrivalDate,
    departureDate,
  } = accommodationPacket;


  const changeDates = () => {
    const arrival = dayjs(arrivalDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
    const departure = dayjs(departureDate, 'YYYY-MM-DD').format('YYYY-MM-DD')

    const params = new URLSearchParams(location.search);

    params.set('arrival_date', arrival);
    params.set('departure_date', departure);

    history.push(`/hotels/${alias}?${params.toString()}`);

  }

  const days = getDifferenceInNights(arrivalDate, departureDate);
  const startFormat = dayjs(arrivalDate, 'YYYY-MM-DD').format('DD.MM');
  const endFormat = dayjs(departureDate, 'YYYY-MM-DD').format('DD.MM');

  return (
    <div className={c.accommodationPackageMobile}>
      <div className={c.accommodationPackageMobileMeal}>
        <div className={c.accommodationPackageMobileMealText}>{price.mealType && price.mealType.name}</div>
      </div>

      <div className={c.accommodationPackageMobileText}>
        {t('accommodation_package_message', {count: days, startFormat, endFormat})}
      </div>


      <AppButton
        onClick={changeDates} theme={'outline'}
        color={'green'}
        size="small"
      >
        {t("Змінити дати")}
      </AppButton>
    </div>
  );
};

export default AccommodationPackageMobile;